import { GigyaRequest } from '../RequestFactory.js'
import { ISigner } from './ISigner.js'
import { isCredentials } from './AuthRequestSigner.js'

export type PartnerSecret = string

export function hasPartnerSecret(
	credentials: { secret: PartnerSecret } | any
): credentials is { secret: PartnerSecret } {
	return !!credentials.secret && !isCredentials(credentials)
}

export class PartnerSecretSigner implements ISigner {
	constructor(protected secret: PartnerSecret) {}

	public sign(request: GigyaRequest<{ secret: PartnerSecret }>) {
		request.params.secret = this.secret
	}
}
